module.exports = __webpack_public_path__ + "static/img/logo.46cfc0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/logo.png
// module id = 13rT
// module chunks = 3